import { isAbsoluteUrl } from '@gbds/core/src/ts/utils'
import { authWaypointTarget, selfScriptEl } from './script-attributes'

export enum WaypointPathValues {
	waypointSuffix = '/auth-waypoint.html',
}

const RELAY_TOKEN_WAYPOINT_SUFFIX = '/relay-token-waypoint.html'

function resolveToAbsoluteHref(href: string): string {
	if (isAbsoluteUrl(href)) {
		return href
	}
	return new URL(href, window.location.origin).href
}

export const getWaypointTarget = (defaultWaypointTarget: string = WaypointPathValues.waypointSuffix): string => {
	// Return explicitly set waypoint target if available
	if (authWaypointTarget) {
		return authWaypointTarget
	}

	// Construct waypoint URL from script source
	// Extract directory path from script URL and append waypoint HTML file
	const scriptPath = new URL(selfScriptEl.src).pathname
	const directoryPath = scriptPath.substring(0, scriptPath.lastIndexOf('/'))
	const waypointPath = directoryPath + defaultWaypointTarget

	return window.location.origin + waypointPath
}

/**
 * Absolute relay-token waypoint URL (same GBPE code path as the bundle, sibling of `auth-waypoint.html`).
 * Used when IdPs require a fixed OAuth redirect such as `relay-token-waypoint.html` instead of `auth-waypoint.html`.
 */
export function getRelayTokenWaypointAbsoluteUrl(): string {
	const explicit = authWaypointTarget?.trim()
	if (explicit) {
		if (/relay-token-waypoint\.html/i.test(explicit)) {
			return resolveToAbsoluteHref(explicit)
		}
		if (/auth-waypoint\.html/i.test(explicit)) {
			return resolveToAbsoluteHref(explicit.replace(/auth-waypoint\.html/gi, 'relay-token-waypoint.html'))
		}
	}
	const scriptPath = new URL(selfScriptEl.src).pathname
	const directoryPath = scriptPath.substring(0, scriptPath.lastIndexOf('/'))
	return window.location.origin + directoryPath + RELAY_TOKEN_WAYPOINT_SUFFIX
}
